import manager from 'app/module46/component-manager.js';

console.log('registering pricing-form');
manager.register('pricing-form', pricingForm);

/**
 * @param {HTMLFormElement} component
 * @param {Object.<string, Element>} references
 * @param {Array.<Element>} references.errors
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function pricingForm(component, references, attributes, properties) {
	const {
		wholeEventInput,
		daysInput
	} = references;

	const container = daysInput.parentElement.parentElement;

	const handlePricingType = () => {
		if (wholeEventInput.checked) {
			container.style.display = 'none';
		} else {
			container.style.removeProperty('display');
		}
	};

	wholeEventInput.addEventListener('change', handlePricingType);
	handlePricingType();
}
